import Nav from "./../Page/Share/Nav/Nav";
const Post10 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Nikon shoes logo design
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://cdn.dribbble.com/users/6827497/screenshots/18088713/media/40276fc3a850b86db373dcc8819f8f1d.jpg" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post10;
